// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_wrapper__RAsdB {
  margin-top: 60px;
  padding-bottom: 50px;
}
.Footer_wrapper__RAsdB .Footer_container__iICw7 .Footer_social__MfQNF {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 60px;
}
.Footer_wrapper__RAsdB .Footer_container__iICw7 .Footer_social__MfQNF .Footer_left__uf-wb {
  align-items: center;
  display: flex;
  gap: 24px;
}
.Footer_wrapper__RAsdB .Footer_container__iICw7 .Footer_social__MfQNF .Footer_right__rtqAj {
  align-items: center;
  display: flex;
  gap: 24px;
}
.Footer_wrapper__RAsdB .Footer_container__iICw7 .Footer_social__MfQNF .Footer_right__rtqAj .Footer_socialItem__hswMP path {
  transition: all 0.2s linear;
}
.Footer_wrapper__RAsdB .Footer_container__iICw7 .Footer_social__MfQNF .Footer_right__rtqAj .Footer_socialItem__hswMP:hover path {
  fill: #EAD40C;
}
.Footer_wrapper__RAsdB .Footer_container__iICw7 .Footer_license_offer__hMRs3 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}
.Footer_wrapper__RAsdB .Footer_container__iICw7 .Footer_license__UeNBU {
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
  color: #E0E0E0;
  text-align: center;
}
.Footer_wrapper__RAsdB .Footer_container__iICw7 .Footer_offer__s6ryv {
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
  color: #E0E0E0;
  text-align: center;
  cursor: pointer;
}

@media (max-width: 850px) {
  .Footer_wrapper__RAsdB {
    margin-top: 100px;
  }
  .Footer_wrapper__RAsdB .Footer_container__iICw7 .Footer_social__MfQNF {
    display: block;
  }
  .Footer_wrapper__RAsdB .Footer_container__iICw7 .Footer_social__MfQNF .Footer_left__uf-wb {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin: 0 auto;
    width: 300px;
  }
  .Footer_wrapper__RAsdB .Footer_container__iICw7 .Footer_social__MfQNF .Footer_right__rtqAj {
    margin: 24px auto;
    width: 300px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,oBAAA;AADF;AAKI;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAHN;AAKM;EACE,mBAAA;EACA,aAAA;EACA,SAAA;AAHR;AAMM;EACE,mBAAA;EACA,aAAA;EACA,SAAA;AAJR;AAOU;EACE,2BAAA;AALZ;AASQ;EACE,aAAA;AAPV;AAYI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAVN;AAaI;ECqDF,eAAA;EACA,gBAAA;EACA,kBAAA;EDrDI,cAAA;EACA,kBAAA;AATN;AAYI;EC+CF,eAAA;EACA,gBAAA;EACA,kBAAA;ED/CI,cAAA;EACA,kBAAA;EACA,eAAA;AARN;;AAaA;EACE;IACE,iBAAA;EAVF;EAcI;IACE,cAAA;EAZN;EAcM;IACE,aAAA;IACA,qCAAA;IACA,cAAA;IACA,YAAA;EAZR;EAeM;IACE,iBAAA;IACA,YAAA;EAbR;AACF","sourcesContent":["@import '../../assets/styles/global.scss';\n\n.wrapper {\n  margin-top: 60px;\n  padding-bottom: 50px;\n\n  .container {\n\n    .social {\n      align-items: center;\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 60px;\n\n      .left {\n        align-items: center;\n        display: flex;\n        gap: 24px;\n      }\n\n      .right {\n        align-items: center;\n        display: flex;\n        gap: 24px;\n\n        .socialItem {\n          path {\n            transition: all .2s linear;\n          }\n        }\n\n        .socialItem:hover path {\n          fill: #EAD40C;\n        }\n      }\n    }\n\n    .license_offer {\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      align-items: center;\n    }\n    \n    .license {\n      @include helper;\n      color: #E0E0E0;\n      text-align: center;\n    }\n    \n    .offer {\n      @include helper;\n      color: #E0E0E0;\n      text-align: center;\n      cursor: pointer;\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .wrapper {\n    margin-top: 100px;\n\n    .container {\n      \n      .social {\n        display: block;\n\n        .left {\n          display: grid;\n          grid-template-columns: repeat(2, 1fr);\n          margin: 0 auto;\n          width: 300px;\n        }\n\n        .right {\n          margin: 24px auto;\n          width: 300px;\n        }\n      }\n    }\n  }\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Footer_wrapper__RAsdB`,
	"container": `Footer_container__iICw7`,
	"social": `Footer_social__MfQNF`,
	"left": `Footer_left__uf-wb`,
	"right": `Footer_right__rtqAj`,
	"socialItem": `Footer_socialItem__hswMP`,
	"license_offer": `Footer_license_offer__hMRs3`,
	"license": `Footer_license__UeNBU`,
	"offer": `Footer_offer__s6ryv`
};
export default ___CSS_LOADER_EXPORT___;
